// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  body * {
    visibility: hidden;
  }

  #printable-order-details,
  #printable-order-details * {
    visibility: visible;
  }

  #printable-order-details {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  #delivery-note-content,
  #delivery-note-content * {
    visibility: visible;
  }

  #delivery-note-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .no-print {
    display: none !important;
  }

  /* Expand textareas (e.g. Additional Notes) to show full content */
  .flex-grow-1.border.rounded.bg-white.p-2 {
    max-height: none !important;
    overflow: visible !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/custom.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;EACb;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,kEAAkE;EAClE;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF","sourcesContent":["@media print {\r\n  body * {\r\n    visibility: hidden;\r\n  }\r\n\r\n  #printable-order-details,\r\n  #printable-order-details * {\r\n    visibility: visible;\r\n  }\r\n\r\n  #printable-order-details {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n  }\r\n\r\n  #delivery-note-content,\r\n  #delivery-note-content * {\r\n    visibility: visible;\r\n  }\r\n\r\n  #delivery-note-content {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n  }\r\n\r\n  .no-print {\r\n    display: none !important;\r\n  }\r\n\r\n  /* Expand textareas (e.g. Additional Notes) to show full content */\r\n  .flex-grow-1.border.rounded.bg-white.p-2 {\r\n    max-height: none !important;\r\n    overflow: visible !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
